import p from "./index.es243.js";
import f from "./index.es301.js";
import h from "./index.es300.js";
import w from "./index.es344.js";
function b(r, n) {
  return A(r) || T(r, n) || y(r, n) || E();
}
function E() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function y(r, n) {
  if (r) {
    if (typeof r == "string") return g(r, n);
    var e = {}.toString.call(r).slice(8, -1);
    return e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set" ? Array.from(r) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? g(r, n) : void 0;
  }
}
function g(r, n) {
  (n == null || n > r.length) && (n = r.length);
  for (var e = 0, t = Array(n); e < n; e++) t[e] = r[e];
  return t;
}
function T(r, n) {
  var e = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (e != null) {
    var t, a, l, o, c = [], i = !0, s = !1;
    try {
      if (l = (e = e.call(r)).next, n !== 0) for (; !(i = (t = l.call(e)).done) && (c.push(t.value), c.length !== n); i = !0) ;
    } catch (u) {
      s = !0, a = u;
    } finally {
      try {
        if (!i && e.return != null && (o = e.return(), Object(o) !== o)) return;
      } finally {
        if (s) throw a;
      }
    }
    return c;
  }
}
function A(r) {
  if (Array.isArray(r)) return r;
}
function N(r, n, e, t, a, l) {
  if (e === null && !a)
    return "";
  var o = {
    r: h(n, r)
  };
  if (a && (o.s = a), e === null)
    return "<c".concat(f(o), "/>");
  if (t === Date && !a)
    throw new Error('No "format" has been specified for a Date cell');
  var c = v(t, e, l), i = x(t);
  i && (o.t = i);
  var s = S(t), u = b(s, 2), m = u[0], d = u[1];
  return "<c".concat(f(o), ">") + m + c + d + "</c>";
}
function x(r) {
  switch (r) {
    case String:
      return "s";
    // I don't know why did I comment out the use of "inlineStr" XLSX type.
    // Perhaps there were some issues with it. Or perhaps there weren't and everyone else just uses "s".
    // // "inlineStr" type is used instead of "s" to avoid creating a "shared strings" index.
    // return 'inlineStr'
    case Number:
      return;
    case Date:
      return;
    case Boolean:
      return "b";
    case "Formula":
      return;
    default:
      throw new Error("Unknown schema type: ".concat(r && r.name || r));
  }
}
function v(r, n, e) {
  switch (r) {
    case String:
      if (typeof n != "string")
        throw new Error("Invalid cell value: ".concat(n, ". Expected a string"));
      return e(n);
    case Number:
      if (typeof n != "number")
        throw new Error("Invalid cell value: ".concat(n, ". Expected a number"));
      return String(n);
    case Date:
      if (!(n instanceof Date))
        throw new Error("Invalid cell value: ".concat(n, ". Expected a Date"));
      return String(w(n));
    case Boolean:
      if (typeof n != "boolean")
        throw new Error("Invalid cell value: ".concat(n, ". Expected a boolean"));
      return n ? "1" : "0";
    case "Formula":
      if (typeof n != "string")
        throw new Error("Invalid cell value: ".concat(n, ". Expected a string"));
      return p(n);
    default:
      throw new Error("Unknown schema type: ".concat(r && r.name || r));
  }
}
var _ = /</g;
function S(r) {
  var n = C(r), e = n.replace(_, "</");
  return [n, e];
}
function C(r) {
  switch (r) {
    // case 'inlineStr':
    //   return '<is><t>'
    case "Formula":
      return "<f>";
    default:
      return "<v>";
  }
}
export {
  N as default
};
//# sourceMappingURL=index.es328.js.map
